import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-sand-100 mx-auto mb-6">
          <svg className="h-12 w-12 text-sand-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-sand-900 mb-2">404</h1>
        <p className="text-xl text-sand-600 mb-4">Page not found</p>
        <p className="text-sand-500 max-w-md mb-8">
          Sorry, we couldn&apos;t find the page you&apos;re looking for. It might have been moved or no longer exists.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="sage">Go Home</Button>
          </Link>
          <Link to="/tee-times">
            <Button variant="outline">Browse Tee Times</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
